import { render, staticRenderFns } from "./RolePermissionsList.vue?vue&type=template&id=336d1da2&scoped=true&lang=pug&"
import script from "./RolePermissionsList.vue?vue&type=script&lang=js&"
export * from "./RolePermissionsList.vue?vue&type=script&lang=js&"
import style0 from "./RolePermissionsList.vue?vue&type=style&index=0&id=336d1da2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336d1da2",
  null
  
)

export default component.exports